import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as visibilityActions from './visibility.actions';
import { VisibilityService } from './visibility.service';

@Injectable()
export class VisibilityEffects {
    private actions$ = inject(Actions);
    private visibilityService = inject(VisibilityService);

    getVisibilityForId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(visibilityActions.getVisibilityForId),
            mergeMap((action) =>
                this.visibilityService
                    .getVisibilityForId(action.entityType, action.entityId)
                    .pipe(
                        map((visibility) =>
                            visibilityActions.getVisibilityForIdSuccess({
                                entityType: action.entityType,
                                entityId: action.entityId,
                                visibility,
                            }),
                        ),
                        catchError((error) =>
                            of(
                                visibilityActions.getVisibilityForIdFailure({
                                    entityType: action.entityType,
                                    entityId: action.entityId,
                                    error,
                                }),
                            ),
                        ),
                    ),
            ),
        ),
    );
}
